import { useIsInternal } from '@/stores/authStore';
import { useWebSocket } from '@/hooks/useWebSocket';
import {
  TicketsWidget,
  ConversacionesWidget,
  ActividadesWidget,
  ClientesWidget,
  GraficoTicketsWidget,
  ActividadRecienteWidget,
} from './widgets';

export function Dashboard() {
  const isInternal = useIsInternal();
  const { isConnected } = useWebSocket();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Dashboard
          </h1>
          <p className="text-gray-500 dark:text-gray-400">
            Resumen de actividad del sistema
          </p>
        </div>
        {isConnected && (
          <div className="flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-400">
            <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
            En vivo
          </div>
        )}
      </div>

      {/* Widgets de conteo */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <TicketsWidget />
        <ConversacionesWidget />
        {isInternal && <ActividadesWidget />}
        {isInternal && <ClientesWidget />}
      </div>

      {/* Gráficos y actividad */}
      <div className="grid gap-4 lg:grid-cols-2">
        <GraficoTicketsWidget />
        <ActividadRecienteWidget />
      </div>
    </div>
  );
}

export default Dashboard;
